import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { InputText } from "primereact/inputtext";
import { updateTransactionRequest } from "../common/customServiceCall/serviceCall";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from "primereact/calendar";
import ReactTooltip from "react-tooltip";
import config from "../../config";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const TransactionControlCenter = () => {
  const history = useHistory();
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [status, setStatus] = useState(null);
  const [reqType, setReqType] = useState(null);
  const [completionData, setCompletionData] = useState({
    request_type: "",
    file: null,
  });
  const isVerified = useRef(false);
  const [verificationStatus, setVerificationStatus] = useState({
    msg: "",
    job_id: 0,
    status: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const toast = useRef(null);

  const userDetails = useSelector((state) => state.login.userDetails);

  const token = userDetails._id;

  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "#999",
    fontWeight: "500",
  };
  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const statusOptions = [
    { label: "Failed", value: "FAILED" },
    { label: "Failed No Retry", value: "FAILED_NO_RETRY" },
    { label: "Success", value: "SUCCESS" },
  ];

  const statusFilter = [
    { label: "Pending", value: "PENDING" },
    { label: "Processing", value: "PROCESSING" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Cancelled", value: "CANCELLED" },
  ];

  const getSearchedData = () => {
    fetchData();
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
      <ReactTooltip id="toolTip1" />
    </>
  );

  const handleViewModalDisplay = (rowData) => {
    history.push(`/job-details/${rowData.id}`, {
      state: { jobId: rowData.id },
    });
  };

  const allFieldsFilled = Object.values(completionData).every(
    (value) => value !== "" && value !== null && value !== undefined
  );
  const handleFileVerification = async () => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", completionData.file);
    formData.append("request_type", completionData.request_type);
    formData.append("token", token);

    if (allFieldsFilled) {
      try {
        const response = await updateTransactionRequest(
          "post",
          "/completion/bulk/upload",
          formData
        );

        setVerificationStatus({
          msg: response.msg,
          job_id: response.data?.id,
          status: response.status,
        });

        if (response.status === 200) {
          isVerified.current = true;
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        const errorMsg =
          error.response?.data?.msg || error.message || "Failed to fetch data";

        setVerificationStatus({
          msg: errorMsg,
          status: error.response?.status,
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      setVerificationStatus({
        msg: "Please fill all fields",
      });
    }
  };

  const handleDownloadSampleFile = async () => {
    try {
      const formData = new FormData();
      formData.append("token", token);

      const url =
        config.main.updateTransactionService +
        "completion/bulk/template/download";

      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        throw new Error("Failed to download file. Status: " + response.status);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "bulk_transaction_template.xlsx";
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error performing download:", error);
    }
  };

  const handleSubmitCompletionRequest = async (action) => {
    const formData = new FormData();
    console.log(verificationStatus, "verificationStatus");

    formData.append("job_id", verificationStatus.job_id);
    formData.append("token", token);
    formData.append("action", action);
    try {
      const response = await updateTransactionRequest(
        "post",
        "/completion/bulk/requests/create",
        formData
      );
      console.log(response, "response");

      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.msg,
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.msg,
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "error",
        life: 3000,
      });
    } finally {
      setShowUploadModal(false);
      setCompletionData({ request_type: "", file: null });
      isVerified.current = false;
      setVerificationStatus({ msg: "", job_id: 0, status: 0 });
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("token", token);
    formData.append("start_date", dateRange ? dateRange.startDate : "");
    formData.append("end_date", dateRange ? dateRange.endDate : "");
    formData.append("request_type", reqType ? reqType : "");
    formData.append("status", status ? status : "");
    formData.append("page", 1);
    formData.append("size", 50);

    try {
      const response = await updateTransactionRequest(
        "post",
        "/completion/bulk/jobs/filter",
        formData
      );
      if (response.code !== 200) {
        setTransactionData(response.data || []);
      } else {
        setTransactionData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  return (
    <>
      <section
        className="p-my-4 p-md-12 p-xl-12"
        style={{ padding: "0px 10%" }}
      >
        <div className="p-col-12 p-md-12 p-xl-12">
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
              style={{ textAlign: "center" }}
            >
              <span className="p-tag custom-heading">
                Transaction Control Center
              </span>
            </div>
          </div>
        </div>
        <div className="" style={{ marginTop: "20px", marginBottom: "20px" }}>
          <div
            className="p-flex"
            style={{
              gap: "10px",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Button
              label="Download Sample File"
              onClick={handleDownloadSampleFile}
              className="p-button-warning"
            />
            <Button
              label="Upload File"
              onClick={() => setShowUploadModal(true)}
              className="p-button-success"
            />
          </div>
        </div>
        <div className="card" style={{ paddingTop: "0px" }}>
          <div
            className="p-grid p-align-center p-justify-center p-fluid"
            style={{ paddingTop: "10px" }}
          >
            {/* Date Range Picker */}
            <div className=" p-col-12 p-md-4">
              <label style={floatLabel}>DATE RANGE</label>
              <span className="p-float-label">
                <Calendar
                  value={dateRange}
                  onChange={(e) => setDateRange(e.value)} // Set date range
                  selectionMode="range"
                  readOnlyInput
                  showIcon
                  placeholder="Select Date Range"
                />
              </span>
            </div>

            {/* Status Dropdown */}
            <div className=" p-col-12 p-md-4 ">
              <label style={floatLabel}>STATUS</label>
              <span className="p-float-label">
                <Dropdown
                  value={status}
                  options={statusFilter}
                  onChange={(e) => setStatus(e.value)}
                  placeholder="Select Status"
                />
              </span>
            </div>

            {/* Search Input */}
            <div className=" p-col-12 p-md-3">
              <label style={floatLabel}>REQUEST TYPE</label>
              <div className="p-inputgroup">
                <Dropdown
                  value={reqType}
                  options={statusOptions}
                  onChange={(e) => setReqType(e.value)}
                  placeholder="Select Status"
                />
              </div>
            </div>

            <div className=" p-col-12 p-md-1">
              <Button
                onClick={getSearchedData}
                icon="pi pi-search"
                className="p-button-info"
                style={{ marginTop: "20px" }}
              />
            </div>
          </div>
        </div>

        <div className="card">
          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <ProgressSpinner
                style={{
                  display: userDetails.showLoader,
                  width: "40px",
                  height: "40px",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  bottom: "50%",
                  right: "50%",
                  zIndex: "1111111111",
                }}
                strokeWidth="3"
                animationDuration=".5s"
              />
            </div>
          ) : (
            <DataTable
              value={transactionData}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50]}
              tableStyle={{ minWidth: "60rem" }}
              className="p-datatable-responsive-demo"
            >
              <Column
                field="file_name"
                header="File Name"
                style={{ width: "40%", fontSize: "13px" }}
              ></Column>
              <Column
                field="request_type"
                header="Request Type"
                style={{ width: "35%", fontSize: "13px" }}
              ></Column>

              <Column
                field="total_count"
                header="Total Count"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="status"
                header="Status"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>

              <Column
                field="created_by_name"
                header="Created By"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>

              <Column
                header="Actions"
                style={{ width: "45%", fontSize: "13px" }}
                body={actions}
              ></Column>
            </DataTable>
          )}
        </div>
        <CustomDialog
          visible={showUploadModal}
          header="Transaction Completion Modal"
          onClose={() => {
            setShowUploadModal(false);
            setCompletionData({ request_type: "", file: null });
            isVerified.current = false;
            setVerificationStatus({ msg: "", job_id: 0, status: 0 });
          }}
        >
          <>
            <div className="p-col-12 p-mt-2">
              <label style={labelStyle}>Choose File</label>

              <InputText
                type="file"
                accept=".xlsx"
                style={{ width: "100%" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file && file.name.endsWith(".xlsx")) {
                    setCompletionData((prev) => ({
                      ...prev,
                      file,
                    }));
                  } else {
                    setVerificationStatus({
                      msg: "Please select a valid .xlsx file",
                    });
                    e.target.value = "";
                  }
                }}
              />
            </div>
            <div className="p-col-12 p-mt-2">
              <label style={labelStyle}>Select completion status:</label>

              <Dropdown
                value={completionData.request_type}
                onChange={(e) =>
                  setCompletionData((prev) => ({
                    ...prev,
                    request_type: e.value,
                  }))
                }
                options={statusOptions}
                optionLabel="label"
                placeholder="Select Status"
                style={{ width: "100%" }}
              />
            </div>
          </>
          {verificationStatus.msg && (
            <div
              className={`p-col-12 p-md-12 p-lg-12 p-xl-12 p-my-3 text-center `}
              style={{
                padding: "2px",
                color: verificationStatus.status === 200 ? "green" : "red",
                display: "flex",
                justifyContent: "end",
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              {verificationStatus.msg}
            </div>
          )}

          {!isVerified.current && (
            <div
              className="p-col-12 p-md-12 p-lg-12 p-xl-12"
              style={{ textAlign: "center", marginTop: "5px" }}
            >
              <Button
                onClick={handleFileVerification}
                label={isLoading ? "Verifying..." : "Verify File"}
                loading={isLoading}
                loadingIcon="pi pi-spinner pi-spin"
                className="p-button-secondary p-mx-auto"
                type="button"
                style={{ width: "50%" }}
                disabled={!allFieldsFilled || isLoading}
              />
            </div>
          )}
          {isVerified.current && (
            <div
              style={{
                textAlign: "center",
                marginTop: "5px",
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Button
                onClick={() => handleSubmitCompletionRequest("CONFIRM")}
                label="Confirm"
                className="p-button-info "
                type="submit"
              />
              <Button
                onClick={() => handleSubmitCompletionRequest("CANCEL")}
                label="Decline"
                className="p-button-danger "
              />
            </div>
          )}
        </CustomDialog>
        <Toast ref={toast} />
      </section>
    </>
  );
};
